import { render, staticRenderFns } from "./SearchOld.vue?vue&type=template&id=5d39f3d8&scoped=true&"
import script from "./SearchOld.vue?vue&type=script&lang=js&"
export * from "./SearchOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d39f3d8",
  null
  
)

export default component.exports